<template lang="pug">
  v-list(color="transparent")
    v-card.mb-4(
      v-for="(document, i) in documents"
      :key="i"
      flat
      max-width="700px"
    )
      v-card-text.d-flex.align-center
        a(target="_blank" :href="document.url")
          v-btn(fab icon small color="primary")
            v-icon mdi-download
        p {{ document.original_name }}
</template>

<script>

export default {
  props:{
    documents:{ type:Array, required:true, defalut:() => ([]) },
  },
};
</script>

<style lang='scss'>
</style>
